<!-- 日营业统计 -->
<template>
    <div v-loading="loading">
        <div id="printContent" class="print-zone">
            <div>
                <div id="top">
                    <div class="print-title-view">
                        <div v-if="isEditTitle" class="print-title">
                            <el-input type="text" v-model="titleConfig.RValue"></el-input>
                        </div>
                        <div v-else class="print-title">{{ titleConfig.RValue }}</div>
                    </div>
                    <div class="print-orderDetail">
                        <div class="row">
                            <div class="col">
                                <label class="label_l">统计时间：{{ datetime }}</label>
                            </div>
                            <div class="col">
                                <label class="label_l">打印时间：{{ printDate }}</label>
                            </div>
                            <div class="col">
                                <label class="label_r"
                                    >营业额：{{
                                        (summaryData && summaryData.Data5
                                            ? summaryData.Data5 - (summaryData && summaryData.Data9 ? summaryData.Data9 : 0)
                                            : -(summaryData && summaryData.Data9 ? summaryData.Data9 : 0)
                                        ).toFixed(2)
                                    }}</label
                                >
                            </div>
                            <div class="col">
                                <label class="label_r">统计人：{{ name }}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="print-table-main">
                    <div class="summary-zone">
                        <el-container style="height: 100%; width: 390px; margin-right: 8px">
                            <div id="table1">
                                <table width="390px"  cellspacing="0" cellpadding="1" style="border-collapse: collapse;table-layout:fixed;">
                                    <thead>
                                        <tr>
                                            <td width="50%" class="header project">
                                                <div><b>项目</b></div>
                                            </td>
                                            <td width="50%" class="header amount">
                                                <div><b>金额</b></div>
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="project title">出库汇总</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">总单数</td>
                                            <td>
                                                {{
                                                    summaryData && summaryData.Data2
                                                        ? Number(summaryData.Data2) + Number(summaryData && summaryData.Data6 ? summaryData.Data6 : 0)
                                                        : summaryData && summaryData.Data6
                                                        ? summaryData.Data6
                                                        : 0
                                                }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">总数量</td>
                                            <td>
                                                {{
                                                    summaryData && summaryData.Data3
                                                        ? summaryData.Data3 - (summaryData && summaryData.Data7 ? summaryData.Data7 : 0)
                                                        : -(summaryData && summaryData.Data7 ? summaryData.Data7 : 0)
                                                }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">总成本</td>
                                            <td>
                                                {{
                                                    (summaryData && summaryData.Data4
                                                        ? summaryData.Data4 - (summaryData && summaryData.Data8 ? summaryData.Data8 : 0)
                                                        : -(summaryData && summaryData.Data8 ? summaryData.Data8 : 0)
                                                    ).toFixed(2)
                                                }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">总销售金额</td>
                                            <td>
                                                {{
                                                    (summaryData && summaryData.Data5
                                                        ? summaryData.Data5 - (summaryData && summaryData.Data9 ? summaryData.Data9 : 0)
                                                        : -(summaryData && summaryData.Data9 ? summaryData.Data9 : 0)
                                                    ).toFixed(2)
                                                }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">总减收金额</td>
                                            <td>{{ summaryData && summaryData.data5 ? summaryData.data5 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subctitle">出库单数</td>
                                            <td>{{ summaryData && summaryData.Data2 ? summaryData.Data2 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subctitle">出库数量</td>
                                            <td>{{ summaryData && summaryData.Data3 ? summaryData.Data3 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subctitle">出库成本</td>
                                            <td>{{ summaryData && summaryData.Data4 ? summaryData.Data4 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subctitle">出库金额</td>
                                            <td>{{ summaryData && summaryData.Data5 ? summaryData.Data5 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subctitle">出库退货单数</td>
                                            <td>{{ summaryData && summaryData.Data6 ? summaryData.Data6 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subctitle">出库退货数量</td>
                                            <td>{{ summaryData && summaryData.Data7 ? summaryData.Data7 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subctitle">出库退货成本</td>
                                            <td>{{ summaryData && summaryData.Data8 ? summaryData.Data8 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subctitle">出库退货金额</td>
                                            <td>{{ summaryData && summaryData.Data9 ? summaryData.Data9 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project title">出库明细</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">销售出库单数</td>
                                            <td>{{ summaryData && summaryData.Data2 ? summaryData.Data2 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">销售出库金额</td>
                                            <td>{{ summaryData && summaryData.Data5 ? summaryData.Data5 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">销售退货单数</td>
                                            <td>{{ summaryData && summaryData.Data6 ? summaryData.Data6 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">销售退货金额</td>
                                            <td>{{ summaryData && summaryData.Data9 ? summaryData.Data9 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">调拨出库单数</td>
                                            <td>{{ summaryData && summaryData.Data10 ? summaryData.Data10 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project title">入库汇总</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">总单数</td>
                                            <td>
                                                {{
                                                    summaryData && summaryData.Data11
                                                        ? Number(summaryData.Data11) + Number(summaryData && summaryData.Data14 ? summaryData.Data14 : 0)
                                                        : summaryData && summaryData.Data14
                                                        ? summaryData.Data14
                                                        : 0
                                                }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">总数量</td>
                                            <td>
                                                {{
                                                    summaryData && summaryData.Data12
                                                        ? summaryData.Data12 - (summaryData && summaryData.Data15 ? summaryData.Data15 : 0)
                                                        : -(summaryData && summaryData.Data15 ? summaryData.Data15 : 0)
                                                }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">总成本</td>
                                            <td>
                                                {{
                                                    (summaryData && summaryData.Data13
                                                        ? summaryData.Data13 - (summaryData && summaryData.Data16 ? summaryData.Data16 : 0)
                                                        : -(summaryData && summaryData.Data16 ? summaryData.Data16 : 0)
                                                    ).toFixed(2)
                                                }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="project subctitle">入库单数</td>
                                            <td>{{ summaryData && summaryData.Data11 ? summaryData.Data11 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subctitle">入库数量</td>
                                            <td>{{ summaryData && summaryData.Data12 ? summaryData.Data12 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subctitle">入库成本</td>
                                            <td>{{ summaryData && summaryData.Data13 ? summaryData.Data13 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subctitle">入库退货单数</td>
                                            <td>{{ summaryData && summaryData.Data14 ? summaryData.Data14 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subctitle">入库退货数量</td>
                                            <td>{{ summaryData && summaryData.Data15 ? summaryData.Data15 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subctitle">入库退货成本</td>
                                            <td>{{ summaryData && summaryData.Data16 ? summaryData.Data16 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project title">入库明细</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">采购入库单数</td>
                                            <td>{{ summaryData && summaryData.Data11 ? summaryData.Data11 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">采购入库成本</td>
                                            <td>{{ summaryData && summaryData.Data13 ? summaryData.Data13 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">采购退货单数</td>
                                            <td>{{ summaryData && summaryData.Data14 ? summaryData.Data14 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">采购退货成本</td>
                                            <td>{{ summaryData && summaryData.Data16 ? summaryData.Data16 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">调拨入库单数</td>
                                            <td>{{ summaryData && summaryData.Data17 ? summaryData.Data17 : 0 }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </el-container>
                        <el-container style="height: 100%; width: 390px;">
                            <div id="table2">
                                <table width="390px" cellspacing="0" cellpadding="1" style="border-collapse: collapse;table-layout:fixed;">
                                    <thead>
                                        <tr>
                                            <td width="50%" class="header project">
                                                <div><b>项目</b></div>
                                            </td>
                                            <td width="50%" class="header amount">
                                                <div><b>金额</b></div>
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="project title">利润表</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">业务收入</td>
                                            <td>{{ summaryData && summaryData.Data18 ? summaryData.Data18 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">业务成本</td>
                                            <td>{{ summaryData && summaryData.Data19 ? summaryData.Data19 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">业务利润</td>
                                            <td>{{ summaryData && summaryData.Data20 ? summaryData.Data20 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subctitle">配件利润</td>
                                            <td>
                                                {{
                                                    (
                                                        (summaryData && summaryData.Data18 ? summaryData.Data18 : 0) -
                                                        (summaryData && summaryData.Data19 ? summaryData.Data19 : 0)
                                                    ).toFixed(2)
                                                }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="project subctitle">退货利润</td>
                                            <td>
                                                {{
                                                    (
                                                        (summaryData && summaryData.Data9 ? summaryData.Data9 : 0) -
                                                        (summaryData && summaryData.Data8 ? summaryData.Data8 : 0)
                                                    ).toFixed(2)
                                                }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="project subctitle">优惠金额</td>
                                            <td>{{ summaryData && summaryData.data5 ? summaryData.data5 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subctitle">减收金额</td>
                                            <td>{{ summaryData && summaryData.Data29 ? summaryData.Data29 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">业务利润率</td>
                                            <td>{{ summaryData && summaryData.Data21 ? summaryData.Data21 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project title">日常收支汇总</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">总收款</td>
                                            <td>{{ summaryData && summaryData.Data23 ? summaryData.Data23 : 0 }}</td>
                                        </tr>
                                        <tr :key="'l_' + index" v-for="(item, index) in summaryData.Data22">
                                            <td class="project subctitle">{{ item.PayName }}</td>
                                            <td>{{ item.Amount.toFixed(2) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">总付款</td>
                                            <td>{{ summaryData && summaryData.Data25 ? summaryData.Data25 : 0 }}</td>
                                        </tr>
                                        <tr :key="'i_' + index1" v-for="(item1, index1) in summaryData.Data24">
                                            <td class="project subctitle">{{ item1.PayName }}</td>
                                            <td>{{ item1.Amount.toFixed(2) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">挂账汇总</td>
                                            <td>
                                                {{
                                                    (
                                                        (summaryData && summaryData.Data26 ? summaryData.Data26 : 0) -
                                                        (summaryData && summaryData.Data31 ? summaryData.Data31 : 0)
                                                    ).toFixed(2)
                                                }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="project subctitle">收款挂账</td>
                                            <td>{{ summaryData && summaryData.Data26 ? summaryData.Data26 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subctitle">付款挂账</td>
                                            <td>{{ summaryData && summaryData.Data31 ? summaryData.Data31 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">预收款汇总</td>
                                            <td>{{ summaryData && summaryData.Data40 ? summaryData.Data40 : 0 }}</td>
                                        </tr>
                                        <tr :key="'k_' + index1" v-for="(item1, index1) in summaryData.Data39">
                                            <td class="project subctitle">{{ item1.PayName }}</td>
                                            <td>{{ item1.Amount.toFixed(2) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">预付款汇总</td>
                                            <td>{{ summaryData && summaryData.Data42 ? summaryData.Data42 : 0 }}</td>
                                        </tr>
                                        <tr :key="'m_' + index1" v-for="(item1, index1) in summaryData.Data41">
                                            <td class="project subctitle">{{ item1.PayName }}</td>
                                            <td>{{ item1.Amount.toFixed(2) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project title">应收汇总</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">本期应收</td>
                                            <td>{{ summaryData && summaryData.Data26 ? summaryData.Data26 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">本期收款</td>
                                            <td>{{ summaryData && summaryData.Data27 ? summaryData.Data27 : 0 }}</td>
                                        </tr>
                                        <tr :key="'n_' + index1" v-for="(item1, index1) in summaryData.Data28">
                                            <td class="project subctitle">{{ item1.PayName }}</td>
                                            <td>{{ item1.Amount.toFixed(2) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">预收支付</td>
                                            <td>{{ summaryData && summaryData.Data43 ? summaryData.Data43 : 0 }}</td>
                                        </tr>
                                        <tr :key="'x_' + index1" v-for="(item1, index1) in summaryData.Data44">
                                            <td class="project subctitle">{{ item1.PayName }}</td>
                                            <td>{{ item1.Amount.toFixed(2) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">本期减收</td>
                                            <td>{{ summaryData && summaryData.Data29 ? summaryData.Data29 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">累计欠款</td>
                                            <td>{{ summaryData && summaryData.Data30 ? summaryData.Data30 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project title">应付汇总</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">本期应付</td>
                                            <td>{{ summaryData && summaryData.Data31 ? summaryData.Data31 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">本期付款</td>
                                            <td>{{ summaryData && summaryData.Data32 ? summaryData.Data32 : 0 }}</td>
                                        </tr>
                                        <tr :key="'f_' + index1" v-for="(item1, index1) in summaryData.Data33">
                                            <td class="project subctitle">{{ item1.PayName }}</td>
                                            <td>{{ item1.Amount.toFixed(2) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">预付支付</td>
                                            <td>{{ summaryData && summaryData.Data45 ? summaryData.Data45 : 0 }}</td>
                                        </tr>
                                        <tr :key="'s_' + index1" v-for="(item1, index1) in summaryData.Data46">
                                            <td class="project subctitle">{{ item1.PayName }}</td>
                                            <td>{{ item1.Amount.toFixed(2) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">本期减付</td>
                                            <td>{{ summaryData && summaryData.Data34 ? summaryData.Data34 : 0 }}</td>
                                        </tr>
                                        <tr>
                                            <td class="project subtitle">累计欠款</td>
                                            <td>{{ summaryData && summaryData.Data35 ? summaryData.Data35 : 0 }}</td>
                                        </tr>
                                        <template v-if="sId">
                                            <tr>
                                                <td class="project title">库存汇总</td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td class="project subtitle">库存成本金额</td>
                                                <td>{{ summaryData && summaryData.Data36 ? summaryData.Data36 : 0 }}</td>
                                            </tr>
                                            <tr>
                                                <td class="project subtitle">库存数量</td>
                                                <td>{{ summaryData && summaryData.Data37 ? summaryData.Data37 : 0 }}</td>
                                            </tr>
                                            <tr>
                                                <td class="project subtitle">库存种类</td>
                                                <td>{{ summaryData && summaryData.Data38 ? summaryData.Data38 : 0 }}</td>
                                            </tr>
                                        </template>
                                        <template v-if="!sId" v-for="item2 in summaryData.Data47">
                                            <tr>
                                                <td class="project title">{{ item2.StoName }} 库存汇总</td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td class="project subtitle">库存成本金额</td>
                                                <td>{{ item2.TotalCost }}</td>
                                            </tr>
                                            <tr>
                                                <td class="project subtitle">库存数量</td>
                                                <td>{{ item2.TotalCount }}</td>
                                            </tr>
                                            <tr>
                                                <td class="project subtitle">库存种类</td>
                                                <td>{{ item2.TotalCate }}</td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </el-container>
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="btn-ctn-left">
                <div class="re-set">
                    <el-button class="btn-primary" size="small" @click="isEditTitle = true" v-if="titleConfig == null ? false : titleConfig.Result && !isEditTitle"
                        >编辑标题</el-button
                    >
                    <el-button class="btn-primary" size="small" @click="submitTitleConfig()" v-if="isEditTitle">保存标题</el-button>
                </div>
            </div>
            <div class="re-submit">
                <el-button class="btn-primary" size="small" @click="lodopPrint" v-if="!isDefaultSet">打印</el-button>
                <el-button class="btn-primary" size="small" @click="printedRecord" v-print="'#printContent'" v-else>打印</el-button>
                <el-button size="small" @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    components: {},
    props: ['date', 'summaryData', 'isDefaultSet', 'isPreview', 'sId'],
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            loading: true,
            name: userMsg.EmployeeName,
            entpName: userMsg.EntpName,
            datetime: '',
            printDate: '',
            isEditTitle: false, //编辑标题
            titleConfig: {
                RValue: userMsg.EntpName + '日营业统计'
            } //标题配置
        };
    },
    watch: {},
    created() {},
    mounted() {
        let that = this;
        that.getConfigByCodes();
        that.datetime = that.$util.formatDateV2(that.date);
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth() + 1, d.getDate()];
        that.printDate = `${year1}/${month1}/${day1}`;
        that.loading = false;
    },
    methods: {
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['dyryyebt'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'dyryyebt':
                                    this.titleConfig = data[i];
                                    if (!this.titleConfig || !this.titleConfig.RValue) this.titleConfig.RValue = this.entpName + '日营业统计';
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                let topStyle = `
                    body{margin: 0 auto;width: 210m;}               
                    .print-title-view {
                        width: 100%;
                        position: relative;
                        justify-content: space-between;
                        align-items: flex-end;
                        padding: 20px 0;
                        padding-bottom:10px;
                    }

                    .print-title-view .print-title {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        max-width: 50%;
                        margin: 0 auto;
                        text-align: center;
                        font-size: 20px;
                        font-weight: bold;
                        color: #000;
                        min-height: 26px;
                    } 
                    .print-orderDetail {
                        margin-bottom: 10px;
                        font-size: 14px;
                        color: #000;
                    }

                    .print-orderDetail .row {
                        display: flex;
                        flex-direction: row;
                    }

                    .print-orderDetail .row .col {
                        float: left;
                        -webkit-box-sizing: border-box;
                        box-sizing: border-box;
                        padding-left: 10px;
                        padding-right: 10px;
                        line-height: 18px;
                        height: 18px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        width: 33%;
                    }                                  
               `;
                var tableStyle = `table,
                            td,
                            th {
                                border: 1px solid #000;
                                color: #000;
                                padding-bottom: 3px;
                                padding-top: 3px;
                                padding-left: 10px;
                            }
                            .project {
                                width: 220px;
                            }
                            .amount {
                                width: 146px;
                            }
                            .header {
                                background-color: rgb(242, 246, 252);
                            }
                            .title {
                                font-weight: 700;
                            }
                            .subtitle {
                                padding-left: 25px;
                            }
                            .subctitle {
                                padding-left: 50px;
                            }`;

                // let contentHeight1 = document.getElementById('table1').clientHeight;
                // let contentHeight2 = document.getElementById('table2').clientHeight;
                let printContentHeight = document.getElementById('printContent').clientHeight;
                let topHeight = document.querySelector('#printContent #top').clientHeight;
                // let height = contentHeight1 > contentHeight2 ? contentHeight1 : contentHeight2;
                if (printContentHeight <= 1080) {
                    LODOP.SET_PRINT_PAGESIZE(3, '210mm', '20mm', ''); // 这里3表示纵向打印且纸高“按内容的高度”；580表示纸宽58mm；45表示页底空白4.5mm
                }
                LODOP.ADD_PRINT_HTM('0', '0', '100%', '100%', `<style>${topStyle}</style>` + document.querySelector('#printContent #top').innerHTML);
                // top,left,width,height,htmlContent
                LODOP.ADD_PRINT_TABLE(topHeight, 0, '50%', `BottomMargin:0px`, `<style>${tableStyle}</style>` + document.getElementById('table1').innerHTML);
                LODOP.ADD_PRINT_TABLE(topHeight, 400, '50%', `BottomMargin:0px`, `<style>${tableStyle}</style>` + document.getElementById('table2').innerHTML);
                LODOP.SET_PRINT_STYLEA(0, 'TableHeightScope', 2); //高度包含页头
                // //次页开始的上边距偏移量
                LODOP.SET_PRINT_STYLEA(0, 'Offset2Top', -topHeight + 3);
                //选择操作系统中设为“默认”的打印机，“-1”代表默认打印机
                LODOP.SET_PRINTER_INDEX(-1);
                // LODOP.PRINT_DESIGN();

                if (this.isPreview) LODOP.PREVIEW();
                //预览
                else LODOP.PRINT(); // 直接打印
            }
        },
        // 取消
        cancel() {
            this.$emit('closeDialog');
        },
        //提交打印标题
        submitTitleConfig() {
            this.isEditTitle = false;
            this.$util.setSysConfigValue(this.titleConfig.ConfigId, this.titleConfig.RValue);
        },
        printedRecord() {}
    }
};
</script>
<style lang="less" scoped media="print">
#table1,
#table2 {
    table,
    td,
    th {
        border: 1px solid #000;
        color: #000;
        padding-bottom: 3px;
        padding-top: 3px;
        padding-left: 10px;
    }

    .project {
        width: 220px;
    }

    .amount {
        width: 170px;
    }

    .header {
        background-color: rgb(242, 246, 252);
    }

    .title {
        font-weight: 700;
    }

    .subtitle {
        padding-left: 25px;
    }

    .subctitle {
        padding-left: 50px;
    }
}

.print-zone {
    width: 210mm;
}

.print-title-view {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 20px 0;
}

.print-title-view .print-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 50%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
    min-height: 26px;
}

.print-table-main {
    width: 792px;
    font-size: 12px;
}

.print-table-main .theader {
    text-align: center;
    font-weight: bold;
}

.print-table-main .tcen {
    text-align: center;
}

.print-table-main .tright {
    text-align: right;
    padding-right: 5px;
}

.print-table-main .div-table-cell {
    overflow: hidden;
    word-break: break-all;
    word-wrap: break-word;
    height: auto;
    line-height: 25px;
    padding-left: 1px;
    border-top: 1px solid #000;
    border-right: 1px solid #000;
    border-bottom: 1px solid #000;
    color: #000;
    box-sizing: border-box;
}

.print-table-main .div-table-row {
    border-left: 1px solid #000;
}

.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
}

.btn-ctn-left {
    display: flex;
}

.re-submit {
    text-align: right;
}

.summary-zone {
    display: flex;
    flex-direction: row;
    width: 792px;
    margin-bottom: 20px;
}

.print-orderDetail {
    margin-bottom: 10px;
    font-size: 14px;
    color: #000;
}

.print-orderDetail .row {
    display: flex;
    flex-direction: row;
}

.print-orderDetail .row .col {
    float: left;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding-left: 10px;
    padding-right: 10px;
    line-height: 18px;
    height: 18px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 33%;
}
</style>
